<template>
  <q-card class="posts-card">
    <q-toolbar class="text-primary">
      <q-toolbar-title>
        <router-link :to="`clients/${clientId}/posts`" class="link text-primary">
          Social Posts
        </router-link>
      </q-toolbar-title>
      <q-icon name="fa fa-images" size="sm" />
    </q-toolbar>
    <q-separator />
    <q-card-section>
      <loader :task="task" />
      <div v-show="numPosts !== null" class="row">
        <div class="col-6">
          <span class="text-h3 text-bold">{{ numPosts }}</span>
          Posts
        </div>
        <div class="col-6 text-right" style="align-self: flex-end">
          <q-btn
            label="View Social Posts"
            :to="`clients/${clientId}/posts`"
            flat
            rounded
          />
        </div>
      </div>
    </q-card-section>
  </q-card>
</template>

<style lang="scss">
@import '../../styles/quasar.variables';

.posts-card {
  border-bottom: 3px solid $primary;
}
</style>

<script lang="ts">
import { defineComponent } from 'vue';
import Loader from '@/components/loading/AsyncLinearProgress.vue';
import postRepository from '@/social/post/post-repository';
import { allStatuses } from '@/social/post/post';

interface Data {
  numPosts: number|null,
  task: Promise<number>|null,
}

export default defineComponent({
  components: { Loader },
  props: {
    clientId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      numPosts: null,
      task: null,
    };
  },
  watch: {
    clientId: {
      handler() {
        this.load();
      },
      immediate: true,
    },
  },
  methods: {
    async load() {
      this.task = postRepository.count({
        clientIds: [this.clientId],
        statuses: allStatuses(),
      });
      this.numPosts = await this.task;
    },
  },
});
</script>
